export default "__VITE_ASSET__e65986db__"